/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getCustomersRuVFlag } from '../fn/safety-base-customer-controller/get-customers-ru-v-flag';
import { GetCustomersRuVFlag$Params } from '../fn/safety-base-customer-controller/get-customers-ru-v-flag';
import { patchCustomerWithRuVFlag } from '../fn/safety-base-customer-controller/patch-customer-with-ru-v-flag';
import { PatchCustomerWithRuVFlag$Params } from '../fn/safety-base-customer-controller/patch-customer-with-ru-v-flag';

@Injectable({ providedIn: 'root' })
export class SafetyBaseCustomerControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patchCustomerWithRuVFlag()` */
  static readonly PatchCustomerWithRuVFlagPath = '/customer/{customerId}/ruvflag/{ruvInsured}';

  /**
   * patch the customers ruv-flag.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchCustomerWithRuVFlag()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchCustomerWithRuVFlag$Response(params: PatchCustomerWithRuVFlag$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchCustomerWithRuVFlag(this.http, this.rootUrl, params, context);
  }

  /**
   * patch the customers ruv-flag.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchCustomerWithRuVFlag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchCustomerWithRuVFlag(params: PatchCustomerWithRuVFlag$Params, context?: HttpContext): Observable<void> {
    return this.patchCustomerWithRuVFlag$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getCustomersRuVFlag()` */
  static readonly GetCustomersRuVFlagPath = '/customer/{customerId}/ruvflag';

  /**
   * get the customers ruv-flag.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomersRuVFlag()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomersRuVFlag$Response(params: GetCustomersRuVFlag$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return getCustomersRuVFlag(this.http, this.rootUrl, params, context);
  }

  /**
   * get the customers ruv-flag.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomersRuVFlag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomersRuVFlag(params: GetCustomersRuVFlag$Params, context?: HttpContext): Observable<boolean> {
    return this.getCustomersRuVFlag$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
